import {
  GET_TAXONOMY_LIST_REQUEST,
  GET_TAXONOMY_LIST_SUCCESS,
  GET_TAXONOMY_LIST_FAILURE,
  GET_BASE_TAXONOMY,
  GET_BASE_TAXONOMY_WITH_LIFESTYLES,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    baseTaxonomy: {},
    baseTaxonomyWithLifestyles: {},
    error: false,
    loaded: false,
  };
};

const initialState = getInitialState();

const taxonomyList = (state = initialState, action) => {
  const types = {
    [GET_TAXONOMY_LIST_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_TAXONOMY_LIST_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
      loaded: true,
    }),
    [GET_TAXONOMY_LIST_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
    [GET_BASE_TAXONOMY]: () => ({
      ...state,
      baseTaxonomy: action.message,
    }),
    [GET_BASE_TAXONOMY_WITH_LIFESTYLES]: () => ({
      ...state,
      baseTaxonomyWithLifestyles: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default taxonomyList;
